export const IS_SPLINE_DISALLOWED =
  process.env.NEXT_PUBLIC_IS_SPLINE_DISALLOWED === 'true';
